const state = {
    token: '',
    userInfo: {},
  }
  
  const mutations = {
    SET_TOKEN: (state, token) => {
      state.token = token
      sessionStorage.setItem('token', token)
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
  }
  
  const actions = {
   
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }
  